export default "__VITE_ASSET__CHQojPWI__"